var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#FE572A",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 44C52 48.4183 48.4183 52 44 52C39.5817 52 36 48.4183 36 44C36 39.5817 39.5817 36 44 36C48.4183 36 52 39.5817 52 44Z",
    strokeWidth: 4,
    stroke: "#FE572A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27C59.4371 27 67.5408 37.8587 69.6921 43.3115L70 44.0918L69.6217 44.8457C68.2451 47.5872 65.371 51.5774 61.1232 54.9043C56.8537 58.2481 51.0894 61 44 61C36.9106 61 31.1463 58.2481 26.8768 54.9043C22.629 51.5774 19.7549 47.5872 18.3783 44.8457L18 44.0918L18.3079 43.3115C20.4592 37.8587 28.5629 27 44 27ZM44 31C31.7335 31 24.9078 39.1787 22.6864 43.9121C23.9587 46.1499 26.3143 49.2326 29.6508 51.8457C33.3615 54.7518 38.1778 57 44 57C49.8222 57 54.6385 54.7518 58.3492 51.8457C61.6855 49.2327 64.0401 46.1498 65.3126 43.9121C63.091 39.1786 56.2662 31 44 31Z",
    fill: "#FE572A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.0e2b4564d68fbbb8bd5822450cc144d5.svg";
export { ForwardRef as ReactComponent };